import React from 'react';
import { Drawer, PageHeader } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';

const BasicDrawer: React.FC<{
  title: string | undefined;
  onBack: any;
  children: any;
  placement?: DrawerProps['placement'];
}> = ({ title, onBack, children, placement = 'left' }) => {
  return (
    <Drawer
      title={
        <PageHeader
          style={{
            padding: '0px',
          }}
          onBack={onBack}
          title={title}
        />
      }
      width={`80%`}
      visible={true}
      maskClosable={false}
      closable={false}
      placement={placement}
    >
      {children}
    </Drawer>
  );
};

export default BasicDrawer;
